import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'NewPassword',
  props: {
    propPasswords: {
      type: Object,
    },
    isNewPass: {
      type: Boolean,
      default: true
    },
    filedClass: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      passwords: {},
      minLength: 7,
      bStrongPassword: false,
      regAccountValidationRulesTooltip: '',
      messages: { psw1: '', psw2: '' },
      passwordMessage: '',
    }
  },
  computed: {
    password: function () { return this.passwords.password; },
    password2: function () { return this.passwords.password2; }
  },
  watch: {
    password: function (value) {
      if (this.validatePassword(value)) {
        this.passwords.canContinue = this.checkPasswordsMatch();
      }
    },
    password2: function (value) {
      this.passwords.canContinue = this.checkPasswordsMatch();
    }
  },
  created() {
    this.passwords = this.propPasswords;
    this.getPasswordMessage();
    this.getMinPasswordLength();
    this.getPasswordStrength();
    this.getAccountValidationRulesTooltip();
  },
  methods: {
    //regAccountValidationRulesTooltip
    getAccountValidationRulesTooltip() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 56
      };
      axios.post('/Utility/GetMessage', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.regAccountValidationRulesTooltip = response.data.settings.text;
          }
        });
    },
    getMinPasswordLength() {
      axios.post('/Utility/GetPasswordMinimumLength')
        .then(response => {
          if (response.data.data.status == 0) 
            this.minLength = response.data.value
        })
        .catch(e => {
          ;
        })
    },
    getPasswordStrength() {
      axios.post('/Utility/GetSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.bStrongPassword = response.data.value.strongPassword;
          }
        }).catch(e => {
          ;
        })
    },
    validatePassword(psw) {
      // validate password complexity (call API and/or js validator from utils)
      this.messages.psw1 = '';

      if (psw.length == 0) 
        this.messages.psw1 = this.$t('newPassword.NonEmptyPassword');
      else if (psw.length < this.minLength) 
        this.messages.psw1 = this.$t('newPassword.PassLength') + this.minLength + this.$t('newPassword.Characters');
      else if (!this.checkPasswordComplexityLetters(psw))
        this.messages.psw1 = this.$t('newPassword.ComplexityRulesLetters');
      else if (!this.checkPasswordComplexityDigits(psw))
        this.messages.psw1 = this.$t('newPassword.ComplexityRulesDigits');
      else if (!this.checkPasswordComplexitySpecial(psw))
        this.messages.psw1 = this.$t('newPassword.ComplexityRulesSpecial');
      //else if (!this.checkPasswordComplexity(psw))
      //  this.messages.psw1 = this.$t('newPassword.ComplexityRules');
      else
        return true;

      return false;
    },
    checkPasswordsMatch() {
      this.messages.psw2 = '';
      var bCanContinue = true;
      if (this.passwords.password.length > 0 && this.passwords.password2.length > 0) {
        if (this.passwords.password2 != this.passwords.password) {
          this.messages.psw2 = this.$t('newPassword.PassNoMatch');
          bCanContinue = false;
        }
      }
      return bCanContinue;
    },
    //checkPasswordComplexity(psw) {
    //  var letters = /[a-zA-Z]/;
    //  var numbers = /[0-9]/;
    //  var special = /[!|@|#|$|%|^|&|*|(|)|-|_]/;
    //  return psw.match(letters) && psw.match(numbers) && psw.match(special);
    //},
    checkPasswordComplexityLetters(psw) {
      var letters = /[a-zA-Z]/;
      return this.bStrongPassword === true? psw.match(letters): true;
    },
    checkPasswordComplexityDigits(psw) {
      var numbers = /[0-9]/;
      return this.bStrongPassword === true ? psw.match(numbers): true;
    },
    checkPasswordComplexitySpecial(psw) {
      var special = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~¬\\]/;
      return this.bStrongPassword === true ? psw.match(special): true;
    },
    getPasswordMessage() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 86
      };

      axios.post('/Utility/GetMessage', parameter)
        .then(response => {
          if (response.data.data.status == 0)
            this.passwordMessage = response.data.settings.text;
        })
        .catch(e => {
          this.passwordMessage = '';
        })
    }
  }
}
